// src/screens/AdminAccesosScreen.js
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  IoLockOpenOutline, 
  IoBusinessOutline, 
  IoListCircleOutline,
  IoArrowForward, 
  IoShieldCheckmarkOutline
} from 'react-icons/io5';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import './GestionAvisosScreen.css';
import './AccesosScreen.css';

const AccessCard = ({ to, icon, title, description, theme }) => (
  <Link to={to} className={`access-card ${theme}`}>
    <div className="card-icon-wrapper">
      {icon}
    </div>
    <div className="card-content">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
    <div className="card-arrow">
      <IoArrowForward size={24} />
    </div>
  </Link>
);

function AdminAccesosScreen() {
  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/admin/accesos" />

      <main className="ks-main">
        <KondoBrandHeader title="Administración" showBackButton={false} />

        <div className="ks-scroll-area">
          <div className="avisos-dashboard-container">
            
            {/* --- Premium Hero Banner Estandarizado (Sin flecha de atras por ser modulo principal) --- */}
            <div className="muro-header-stitch">
              <div className="muro-hero-card">
                <div className="muro-hero-content">
                  <h1>Accesos Condominio</h1>
                  <p>Configura plumas, portones, proveedores y supervisa la bitácora del fraccionamiento.</p>
                </div>

                <IoShieldCheckmarkOutline className="muro-hero-icon" />
              </div>
            </div>

            {/* --- Grid de Accesos Administrativos --- */}
            <div className="accesos-container" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 15px' }}>
              <div className="accesos-grid">
                
                {/* 1. Control de Acceso Remoto (Relevadores / GPIO / Permisos) */}
                <AccessCard
                  to="/accesos/control-remoto"
                  icon={<IoLockOpenOutline />}
                  title="Control de Acceso Remoto"
                  description="Configura relevadores (GPIO), asigna permisos por rol y acciona plumas y portones en tiempo real."
                  theme="theme-mi-llave"
                />

                {/* 2. Proveedores Generales (Gas, Agua, Reparto) */}
                <AccessCard
                  to="/proveedores-generales"
                  icon={<IoBusinessOutline />}
                  title="Proveedores Generales"
                  description="Administra pipas de agua, camiones de gas, paqueterías de reparto y servicios públicos autorizados."
                  theme="theme-teal"
                />

                {/* 3. Bitácora Global de Accesos */}
                <AccessCard
                  to="/bitacora"
                  icon={<IoListCircleOutline />}
                  title="Bitácora de Accesos"
                  description="Registro histórico y en vivo de entradas y salidas por QR, Biometría Facial, RFID y Apertura Remota."
                  theme="theme-purple"
                />

              </div>
            </div>
          </div>
        </div>

        {/* Floating Island Bottom Nav */}
        <KondoBottomNav activeRoute="/admin/accesos" />
      </main>
    </div>
  );
}

export default AdminAccesosScreen;
